export const reportsPath = '/reports';
